"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringExtensions = void 0;
var comparers_1 = require("@devexpress/utils/lib/utils/comparers");
var StringExtensions = (function () {
    function StringExtensions() {
    }
    StringExtensions.compareInvariantCultureIgnoreCase = function (str1, str2) {
        return comparers_1.Comparers.stringIgnoreCase(str1, str2);
    };
    return StringExtensions;
}());
exports.StringExtensions = StringExtensions;
